import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import Title from '../../../components/Headers/Title';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { LicenseProps } from '../../../types/IdProps';
import DataService from "../../../services/data.service";
import { useNotifications } from '../../../contexts/notificationContext';
import AddItemPopup from '../Popups/License_popup_AddItem';

interface LicenseItemRevisionModel {
    id: number
    licenseId: number
    itemId: number
    itemRevisionId: number
    included: boolean
    excluded: boolean
    thumbnailUrl: string
    itemNr: string
    revisionNr: number
    status: string
    statusColor: string
}

const License_tab_Items: React.FC<LicenseProps> = ({ licenseId }) => {
    const [includedData, setIncludedData] = useState<LicenseItemRevisionModel[]>();
    const [excludedData, setExcludedData] = useState<LicenseItemRevisionModel[]>();
    const [included, setIncluded] = useState<boolean>(false)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();

    useEffect(() => {
        getTableData();
    }, [licenseId]);

    function getTableData() {
        DataService.get<any[]>('api/v1/LicenseItems/ByLicenseIncluded/' + licenseId)
            .then(response => {
                setIncludedData(response);
            })
            .catch(e => { handleException(e); });

        DataService.get<any[]>('api/v1/LicenseItems/ByLicenseExcluded/' + licenseId)
            .then(response => {
                setExcludedData(response);
            })
            .catch(e => { handleException(e); });
    }

    function deleteRow(rowData: LicenseItemRevisionModel) {
        DataService.delete('api/v1/LicenseItems/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const includedColInfos: IColInfo[] = [
        { key: true, dataProp: 'ItemId', visible: false },
        { getCellBackgroundColor: getCellColor, sort: false, width: 5 },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'ItemNr', dataProp: 'itemNr', sort: 'asc' },
        { title: 'Revision', dataProp: 'revisionNr', dataType:'number' },
        { title: 'Status', dataProp: 'status'},
    ];

    const excludedColInfos: IColInfo[] = [
        { key: true, dataProp: 'ItemId', visible: false },
        { getCellBackgroundColor: getCellColor, sort: false, width: 5 },
        { dataProp: 'thumbnailUrl', dataType: 'image' },
        { title: 'ItemNr', dataProp: 'itemNr', sort: 'asc' },
        { title: 'Revision', dataProp: 'revisionNr', dataType: 'number' },
        { title: 'Status', dataProp: 'status' },
    ];

    if (isAuthorizedFor(ApplicationFunctions.UpdateLicense)) {
        includedColInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncluded(true); setShowPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });

        excludedColInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => { setIncluded(false); setShowPopup(true); } }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }]
            });
    }

    function getCellColor(rowData: LicenseItemRevisionModel, colInfo: IColInfo): string | undefined {
        return rowData.statusColor;
    }

    return (
        <Container fluid>
            <Row>
                <Col md='6'>
                    <Title size={4} text='Included' />
                    <DataTable
                        name='dtLicenseIncludedItems'
                        colInfos={includedColInfos}
                        tableData={includedData}
                        navigateTitle={'Item'}
                        navigateUrl={'/plm/Items/ItemRevision/'}
                    />
                </Col>
                <Col md='6'>
                    <Title size={4} text='Excluded' />
                    <DataTable
                        name='dtLicenseExcludedItems'
                        colInfos={excludedColInfos}
                        tableData={excludedData}
                        navigateTitle={'Item'}
                        navigateUrl={'/plm/Items/ItemRevision/'}
                    />
                </Col>
            </Row>
            {showPopup && <AddItemPopup licenseId={licenseId} included={included} show={showPopup} onHide={() => { setShowPopup(false); getTableData(); }} />}
        </Container>

    );
}
export default License_tab_Items;